<template>
    <eg-modalv2
        height="auto"
        width="500px"
        :show="showModal"
        :paddingBody="false"
        :showFooter="false"
        :showHeader="false"
        :rounded="true"
        :scrollable="false"
    >
        <div slot="body" class="modal-body">
            <div class="modal-close" @click="$emit('close')">
                <span class="material-icons-outlined">
                    close
                </span>
            </div>
            <div @click="knowMore" class="modal-img">
                <img :src="imageUrl">
            </div>
            <a @click="doNotShowAgain">{{ textDoNotShow }}</a>
        </div>
    </eg-modalv2>
</template>

<script>
export default {
    name: 'Pop-Up',
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        isMobile: Boolean,
        link: {
            type: String,
        },
        textDoNotShow: {
            type: String,
            default: 'Não exibir esta mensagem novamente'
        },
        imageUrl: {
            type: String,
        },
    },
    data() {
        return {
            linkPage: this.link
        };
    },
    methods: {
        knowMore() {
            this.$emit('knowMore')
            if(this.$props.link) window.open(this.$props.link, '_blank');
        },
        doNotShowAgain() {
            this.$emit('doNotShowAgain')
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-body {
    text-align: center;
    position: relative;
    .modal-title {
        margin-bottom: 16px;
        font-size: 2rem;
        font-weight: 400;
        color: #0d386a;
        @media screen and (max-width: 768px) {
            font-size: 1.5rem
        }
    }
    .modal-text {
        margin-bottom: 16px;
        font-size: 1.4rem;
        font-weight: 400;
        @media screen and (max-width: 768px) {
            font-size: 1rem
        }
    }
    .modal-close {
        position: absolute;
        top: -10px;
        right: -10px;
        color: #707070;
        cursor: pointer;
    }
    .modal-close span {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        background: #fff;
        padding: 5px;
    }
    a {
        font-size: 13px;
        display: block;
        cursor: pointer;
        color: #fff
    }
    .modal-img img {
        max-width: 100%;
        max-height: 500px;
        cursor: pointer
    } 
}
.slide-fade-enter-active {
    transition: all 0.3s ease;
}
.slide-fade-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
}
::v-deep .multiselect__content-wrapper {
    min-width: fit-content;
    box-shadow: 0px 3px 6px #00000029;
    overflow-y: visible;
}

::v-deep .modal-container {
    background-color: transparent;
}
</style>
